import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  RemoveBotConnection,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';
import { BotSelectors } from 'projects/brn-frontend/src/app/core/store/bot/bot.selectors';

@Component({
  selector: 'brn-shopify-connection-modal',
  templateUrl: './shopify-connection-modal.component.html',
  styleUrls: ['./shopify-connection-modal.component.scss'],
})
export class ShopifyConnectionModalComponent implements OnInit {
  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  @ViewSelectSnapshot(BotSelectors.botId)
  botId!: string;
  pendingStatus!: boolean;

  newConnection = true;

  shopifyForm = this.formBuilder.group({
    shop: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ShopifyConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.providerData) {
      this.newConnection = false;
      this.shopifyForm.patchValue(data.providerData);
    }
  }

  ngOnInit(): void { }

  get validForm(): boolean {
    return this.shopifyForm.valid;
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const botId = this.botId || this.data.botId || 'undefined';

    const shop = this.shopifyForm.get('shop')?.value;

    window.location.href = 'https://app.brn.ai/?shop=' + shop + '&bot_id=' + botId + '&redirect=' + window.location.href;

    //this.store.dispatch(new CreateBotConnection('shopify', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.shopifyForm.value;
    this.store.dispatch(new UpdateBotConnection('shopify', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('shopify'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
